import JSZip from 'jszip';
import { buildEx10Pdf } from './ex10FormPdf';

function safeSegment(name, fallback = 'file') {
  const s = String(name || fallback)
    .replace(/[\\/:*?"<>|]+/g, '_')
    .replace(/\s+/g, ' ')
    .trim();
  return s.slice(0, 180) || fallback;
}

/**
 * @param {Function} downloadFile - async (documentId: string) => Blob
 */
export async function buildCasePackageZip({
  downloadFile,
  caseDisplayId,
  isDraft,
  applicantName,
  identityPairs,
  contactPairs,
  addressPairs,
  representativePairs,
  notificationPairs,
  merged,
}) {
  const zip = new JSZip();
  const docFolder = zip.folder('documents');

  const { blob: exBlob, filename: exFilename } = buildEx10Pdf({
    isDraft,
    caseDisplayId,
    applicantName,
    identityPairs,
    contactPairs,
    addressPairs,
    representativePairs,
    notificationPairs,
  });
  zip.file(safeSegment(exFilename, 'EX-10.pdf'), exBlob);

  for (const slot of merged || []) {
    if (!slot.files?.length) continue;
    const slotDir = safeSegment(slot.id, 'misc');
    let idx = 0;
    for (const f of slot.files) {
      const st = String(f.review_status || '').toLowerCase();
      if (st === 'rejected') continue;
      const docId = f.id != null ? String(f.id) : '';
      if (!docId) continue;
      try {
        const blob = await downloadFile(docId);
        if (!(blob instanceof Blob) || blob.size === 0) continue;
        const base = safeSegment(f.filename || `upload_${idx}`, `file_${idx}`);
        const name = slot.files.filter((x) => x !== f).length ? `${idx + 1}_${base}` : base;
        docFolder.file(`${slotDir}/${name}`, blob);
        idx += 1;
      } catch {
        /* skip failed downloads */
      }
    }
  }

  const safeCase = safeSegment(caseDisplayId, 'case').replace(/\s/g, '_');
  const dateStr = new Date().toISOString().slice(0, 10);
  const zipName = `CASE_${safeCase}_package_${dateStr}.zip`;

  const blob = await zip.generateAsync({
    type: 'blob',
    compression: 'DEFLATE',
    compressionOptions: { level: 6 },
  });

  return { blob, filename: zipName };
}
